import type { PropsWithChildren } from 'react'
import Spin from '~/components/Loading/Spin'
import { TRADE_STATUS } from '~/components/TradeDetail/types'
import { useTranslation } from 'react-i18next'
import {
  StyledTipsContent,
  StyledRedeemTipsButton,
  StyledRedeemLonBlurLayer,
} from '../styled'

type Props = PropsWithChildren<{
  status: TRADE_STATUS
  showBlurLayer: boolean
  onRedeemConfirmClick: () => void
}>

const RedeemLonBlurLayer = ({
  status,
  children,
  showBlurLayer,
  onRedeemConfirmClick,
}: Props) => {
  const { t } = useTranslation()

  if (showBlurLayer) {
    return (
      <>
        <StyledTipsContent>
          {t('redeem_lon_modal_tips1')} <br />
          {t('redeem_lon_modal_tips2')} <br />
          <StyledRedeemTipsButton onClick={onRedeemConfirmClick}>
            {!!status ? <Spin /> : t('confirm')}
          </StyledRedeemTipsButton>
        </StyledTipsContent>
        <StyledRedeemLonBlurLayer>{children}</StyledRedeemLonBlurLayer>
      </>
    )
  }
  return children
}

export default RedeemLonBlurLayer
